// extracted by mini-css-extract-plugin
module.exports = {"toast":"Toast_toast__6vpsm","isMobile":"Toast_isMobile__xQkXy"};